import { render } from "./GuessComponent.vue?vue&type=template&id=17cd5731&ts=true"
import script from "./GuessComponent.vue?vue&type=script&lang=ts"
export * from "./GuessComponent.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\breno\\Documents\\Workspace\\Coll\\palavra-quadrada\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__